import { Component, Input, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AlertService } from 'src/app/components/alert/alert.service';
import { TDetailAccordionTypes } from 'src/app/modules/policy/pages/policy-detail/policy-detail.constants';
import { IAccordionItem, IObjectKey } from 'src/app/modules/shared/models/objects';
import { DATE_FORMAT_SLASH, EPolicyTypes, IBeneficiary, IPolicyDetail, IPolicyDocument, Uni30Quota, Uni30Trasferimento } from 'src/app/modules/shared/models/policy.model';
import { LoggerService } from 'src/app/services/logger.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { PolicyService } from '../../policy.service';
import moment = require('moment');

@Component({
  selector: 'app-detail-accordion',
  templateUrl: './detail-accordion.component.html',
  styleUrl: './detail-accordion.component.scss',
})
export class DetailAccordionComponent implements OnDestroy {

  @Input() detail: IPolicyDetail;
  @Input() accordions: IAccordionItem<TDetailAccordionTypes>[] = [];

  policyDocuments: IPolicyDocument[] = [];
  hidePersonalData = false; //environment.name !== 'PROD';
  retrievedQuote: Uni30Quota[] = []
  destroy$ = new Subject();

  constructor(
    private _policyService: PolicyService,
    private _spinner: SpinnerService,
    private _alertService: AlertService
  ) { }

  getTableItem(accordion: IAccordionItem<TDetailAccordionTypes>): IObjectKey {
    const item = accordion.keys.find(x => x.type === 'TABLE');
    return item;
  }

  getPlaceholders(accordion: IAccordionItem<TDetailAccordionTypes>): number[] {
    const tableItem = !!this.getTableItem(accordion) ? 1 : 0;
    const length = accordion?.keys.length - tableItem;
    const array = CommonUtils.getPlaceholders(length, 4);
    return array;
  }

  getValueByPath(detail: any, item: IObjectKey): string {
    const value = CommonUtils.getValueByPath(detail, item);
    return value;
  }

  panelOpened(accordionId: string) {
    if (accordionId === 'DOCUMENTS') {
      this.getPolicyDocuments();
    }
  }

  getTableList(accordion: IAccordionItem<TDetailAccordionTypes>): any[] {
    return CommonUtils.checkAndGet(
      this._policyService.policyDetail,
      this.getTableItem(accordion)?.key,
      null
    );
  }

  getPolicyDocuments(): void {
    this._spinner.show();
    this._policyService.retrievePolicyDocuments(this.policyId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          LoggerService.logInfo(this.constructor.name, 'getPolicyDocuments', response);
          if (response && response.length > 0) {
            this.policyDocuments = response.map((document: IPolicyDocument) => ({
              ...document,
              insertDate: moment(document.insertDate).format(DATE_FORMAT_SLASH)
            }))
          }
          this._spinner.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'getPolicyDocuments', error);
          this._alertService.openErrorMessage('Errore nel recupero dei documenti della polizza', 'getPolicyDocuments', error);
          this._spinner.hide();
        }
      })
  }

  get beneficiaries(): IBeneficiary[] {
    return CommonUtils.checkAndGet(this.detail, 'beneficiaries', null);
  }

  get formattedLegalSubjectKeys(): string[] {
    return this._policyService.formattedLegalSubjectKeys;
  }

  get legalSubjectsKeys(): string[] {
    return this._policyService.formattedLegalSubjectKeys ? Object.keys(this._policyService.formattedLegalSubjectKeys) : null;
  }

  get policyType(): EPolicyTypes {
    return this._policyService.policyType;
  }

  get policyId(): string {
    return this._policyService.policyId;
  }

  get trasferimentiInIngresso(): Uni30Trasferimento[] {
    return CommonUtils.checkAndGet(this.detail, 'intesaFurtherDetails.uni30.trasferimenti', []);
  }

  get trasferimentiTfr(): Uni30Trasferimento[] {
    return CommonUtils.checkAndGet(this.detail, 'intesaFurtherDetails.uni30.trasferimentiTfr', []);
  }

  get trasferimentiTecnici(): Uni30Trasferimento[] {
    return CommonUtils.checkAndGet(this.detail, 'intesaFurtherDetails.uni30.trasferimentiTecnici', []);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  getQuote(date: any) {
    this._spinner.show();
    this._policyService.getMovements(this._policyService.contractNumber, date as moment.Moment)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this._spinner.hide();
          LoggerService.logInfo(this.constructor.name, 'getMovements', response);
          this.retrievedQuote = response;
        },
        error: error => {
          this._spinner.hide();
          LoggerService.logError(this.constructor.name, 'getMovements', error);
          this._alertService.openErrorMessage('Errore nel recupero dei movimenti', 'getMovements', error);
        }
      });
  }

}
